import { Injectable } from "@angular/core";
import { ToastrService, ToastrConfig } from "ngx-toastr";
import { Toast, ToastType } from "../enum/Toast";

@Injectable({
	providedIn: "root",
})
export class ToastService {
	constructor(private toastr: ToastrService) {}

	private showToast(type: ToastType, message: string, title?: string, options?: ToastrConfig) {
		this.toastr[type](message, title, options);
	}

	success(message: string, title?: string, options?: ToastrConfig) {
		this.showToast(Toast.Success, message, title, options);
	}

	error(message: string, title?: string, options?: ToastrConfig) {
		this.showToast(Toast.Error, message, title, options);
	}

	info(message: string, title?: string, options?: ToastrConfig) {
		this.showToast(Toast.Info, message, title, options);
	}

	warning(message: string, title?: string, options?: ToastrConfig) {
		this.showToast(Toast.Waning, message, title, options);
	}
}
